webpackJsonp([133536348556271],{

/***/ 332:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	__webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Contacts | Psychologue Montpellier au quartier des arceaux | Morgane Laroche',
	  description: 'Adresse du cabinet. Coordonnées. Plan d’accès. Lien du site. Matricules. Mon cabinet situé au 300 rue Auguste Broussonnet, quartier des arceaux, à deux pas du tram Place Albert 1er Saint Charles.'
	};
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container container--page' },
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container__block' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-title' },
	        'CONTACTS'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block-contact' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-item__map' },
	          _react2.default.createElement('iframe', {
	            title: 'Cabinet psychologue \xE0 Montpellier',
	            src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11554.321951296171!2d3.8701237!3d43.6152757!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8f38e3a6b95f3e0e!2sMorgane%20Laroche!5e0!3m2!1sfr!2sfr!4v1605720945679!5m2!1sfr!2sfr',
	            allowFullScreen: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-item' },
	          _react2.default.createElement(
	            'ul',
	            {
	              className: 'contact-item__list',
	              itemProp: 'address',
	              itemScope: true,
	              itemType: 'http://schema.org/PostalAddress'
	            },
	            _react2.default.createElement(
	              'li',
	              null,
	              '300 Rue Auguste Broussonnet'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              '34090 Montpellier'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Arr\xEAt de tram Place Albert 1er \u2013 Saint Charles'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'container__block-link',
	                  target: '_blank',
	                  href: 'https://tam.cartographie.pro/'
	                },
	                'Plan d\u2019acc\xE8s',
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-item__list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'container__block-link',
	                  href: 'tel:+33674318234',
	                  itemProp: 'telephone'
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'T\xE9l:'
	                ),
	                ' 06.74.31.82.34',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'container__block-link container__block-link--ellipsis',
	                  href: 'mailto:psychologue.morgane.laroche@gmail.com',
	                  itemProp: 'email'
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'E-mail:'
	                ),
	                ' psychologue.morgane.laroche@gmail.com'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-item__list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Num\xE9ro ADELI\xA0: 34 93 2875 7'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Num\xE9ro Siret\xA0: 833 159 585 00045'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contacts-js-c52bc34889658a125bf5.js